"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M19.185,8.668A3.923,3.923,0,0,0,18.5,6.931a2.747,2.747,0,0,0-1.737-.744C14.346,6,10.685,6,10.685,6s-3.66,0-6.08.186a2.631,2.631,0,0,0-1.737.744,4.2,4.2,0,0,0-.682,1.737A25.288,25.288,0,0,0,2,11.521v1.365a25.288,25.288,0,0,0,.186,2.854,3.923,3.923,0,0,0,.682,1.737,3.026,3.026,0,0,0,1.923.744c1.365.124,5.894.186,5.894.186s3.66,0,6.08-.186a2.747,2.747,0,0,0,1.737-.744,4.2,4.2,0,0,0,.682-1.737,25.288,25.288,0,0,0,.186-2.854V11.521a25.288,25.288,0,0,0-.186-2.854ZM8.886,14.5V9.536L13.6,12.018Z",
    transform: "translate(-2 -6)"
  })
});

var Youtube = function Youtube(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathSolid;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '-0.25 -0.25 18 13';
  }

  if (!mainDimension) {
    mainDimension = 'x';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Youtube-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Youtube;
exports["default"] = _default;

//# sourceMappingURL=index.js.map